import React, {useEffect, useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import Venue from '../../interfaces/Venue';
import './Events.css';
import {fetchVenuesByQuery} from '../../api/endpoints';
import {getVenueUrlParams} from '../../utils/GlobalUtils';
import {useScreenSizeContext} from '../../providers/ScreenSizeProvider';
import {isRight} from 'fp-ts/lib/Either';

const TEVO_PAGE_SIZE = 100;
const PAGE_STEP = 10;

interface QueryVenuesProps {
    query: string;
    initialVenues: Venue[];
    loading: boolean;
}

const QueryVenues: React.FC<QueryVenuesProps> = ({query, initialVenues, loading}) => {
    const pageNumber = useRef<number>(1);

    const [allVenues, setAllVenues] = useState<Venue[]>(initialVenues);
    const [numToShow, setNumToShow] = useState<number>(PAGE_STEP);
    const [loadingMore, setLoadingMore] = useState<boolean>(false);
    const [noMore, setNoMore] = useState<boolean>(false);

    const {isMobile} = useScreenSizeContext();

    useEffect(() => {
        pageNumber.current = 1;
        setAllVenues(initialVenues);
        setNumToShow(PAGE_STEP);
        setNoMore(initialVenues.length < TEVO_PAGE_SIZE);
    }, [initialVenues]);

    const showMore = async () => {
        const localExhausted = numToShow >= allVenues.length;
        if (localExhausted && !noMore && query) {
            setLoadingMore(true);
            const nextPage = pageNumber.current + 1;
            const responseEither = await fetchVenuesByQuery(query, nextPage);
            pageNumber.current = nextPage;
            if (isRight(responseEither)) {
                const fetched = responseEither.right;
                if (fetched.length === 0) {
                    setNoMore(true);
                } else {
                    setAllVenues([...allVenues, ...fetched]);
                    if (fetched.length < TEVO_PAGE_SIZE) {
                        setNoMore(true);
                    }
                }
            } else {
                console.error(responseEither.left);
                setNoMore(true);
            }
            setLoadingMore(false);
        }
        setNumToShow(prev => prev + PAGE_STEP);
    };

    const visible = allVenues.slice(0, numToShow);
    const canShowMore = numToShow < allVenues.length || !noMore;

    return (
        <div className='container-main'>
            <div className='content-main'>
                <div className={`${isMobile ? "left text-m" : "left text-xl"} `}>Venues</div>
                <br/>
                {loading ? (
                    <div className="loading-spinner"></div>
                ) : (
                    <div className='col'>
                        {visible.length > 0 ?
                            <>
                                {visible.map(venue => (
                                    <React.Fragment key={venue.tevoVenueId}>
                                        <Link
                                            to={`/venue/${getVenueUrlParams(venue)}`}
                                            className={`${isMobile ? "col event-bar" : "row event-bar"} `}
                                        >
                                            <div className='col align-start'>
                                                <div className='item-title'>{venue.name}</div>
                                                <div className={`${isMobile ? "text-xxs" : "text-xs-light"} `}>{venue.location}</div>
                                            </div>
                                            <div className='gap'></div>
                                            <button className='action-button' style={isMobile ? {width: '100%', margin: '0px 20px'} : {}}>View Events</button>
                                        </Link>
                                        {isMobile && <div className='divider-margin'/>}
                                    </React.Fragment>
                                ))}
                                {loadingMore ? (
                                    <div>
                                        <br/><br/>
                                        <div className='loading-spinner'/>
                                    </div>
                                ) : canShowMore && (
                                    <div>
                                        <br/><br/>
                                        <button className='filter-button no-margin' onClick={showMore}>Show More</button>
                                    </div>
                                )}
                            </>
                            :
                            <>
                                <br/>
                                <br/>
                                <div className='text-s'>No Venues Found</div>
                                <br/>
                            </>
                        }
                        <br/>
                    </div>
                )}
            </div>
        </div>
    )
}

export default QueryVenues;
